export const Size = {
  ServiceCardIcon: 24,
};
